<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}檔案上傳題
    </template>
    <v-card-text class="text-start" slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <template>
        <v-file-input
          show-size
          label="選擇檔案上傳"
          v-model="ques.file"
          :rules="[
            v => {
              let pass = !(ques.isRequired && !ques.file)
              return pass ? true : '必須選擇上傳的檔案'
            }
          ]"
        ></v-file-input>
      </template>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped></style>
